export const GEMATIK_ROOM = {
  ROOM_TYPE: 'de.gematik.tim.roomtype.default.v1', // standard default gematik room type
  ROOM_DEFAULT: 'de.gematik.tim.room.default.v1', // gematik standard room state event
  ROOM_NAME: 'de.gematik.tim.room.name',      // gematik custom room name event
  ROOM_TOPIC: 'de.gematik.tim.room.topic',  // gematik custom room topic event
};

export const MAX_TOPIC_LENGTH = 200;